import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class HomeService {
    constructor() {
        this.sliderHeader()
    }

    async sliderHeader() {
        const slider = $('[data-swiper="header-banner-slider"]')
        if (slider.length > 0) {
            const swiperKey = 'header-banner-slider'
            const slideItem = `[data-swiper="${swiperKey}"] > .header__banner__item__slide`

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1,
                autoplay: {
                    delay: 4000,
                },
                navigation: {
                    nextEl: '.swiper-home-swiper-next',
                    prevEl: '.swiper-home-swiper-prev',
                },
                pagination: {
                    el: '.home-swiper-pagination',
                    clickable: true,
                },
                grabCursor: true,
                keyboard: true,
                loop: true,
                breakpoints: {
                    600: {
                        speed: 500,
                    },
                    1000: {
                        speed: 1000,
                    },
                },
            }
            $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')
            await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
        }
    }
}
